<template>
  <div class="tab-bd pt30 enroll">
    <div class="enrollList formright">


      <div class="item" v-for="(item,key) in zyNum" :key="key" v-show="item.value!=0">
       <label>第{{item.id}}志愿</label>
        <div class="fl form_right pr">
          <div class="ha_selbox fl"> 
            <Select style="width:330px;text-align:left;" v-model="item.value"   :disabled='disabled' >
              <Option v-for="(key1,value) in specialty" :value="key1.id" :key="value">{{ key1.name }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>毕业类别</label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.bylbm" disabled >
              <Option v-for="(key,value) in dict.bylbm" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>科类</label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.klm" disabled>
              <Option v-for="(key,value) in dict.klm" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
    
      <div class="item">
        <label>学制</label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.xzm" disabled>
              <Option v-for="(key,value) in dict.xz" :value="value" :key="value">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="item">
        <label>考场</label>
        <div class="fl form_right">
          <Input v-model="data.exam_room_name" style="width:330px;text-align:left;" disabled/>
        </div>
      </div>

      <div class="item">
        <label>生源学校</label>
        <div class="fl form_right">
          <Input v-model="data.bmdmc" style="width:330px;text-align:left;" disabled/>
        </div>
      </div>

      <!-- <div class="item">
        <label>考生类别<b class="star"></b></label>
        <div class="fl form_right pr">
          <div class="ha_selbox">
            <Select style="width:330px;text-align:left;" v-model="data.kslbm" :disabled='disabled'>
              <Option v-for="(key,index) in dict.kslbm" :value="index" :key="index">{{ key }}</Option>
            </Select>
          </div>
        </div>
      </div> -->

      <div class="formbutton" v-show="show">
        <a href="javascript:;" @click="modal1 = true" class="btn">提交</a>
      </div>
    </div>

    <!--提示框-->
    <tip :tip="tip" v-if="tipShow">{{tip}}</tip>
    <!--对话框-->
    <Modal
      v-model="modal1"
      title="系统提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>确定要提交吗？</p>
    </Modal>
    <page-load v-if="loading"></page-load>
     <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
  </div>
</template>

<script>
import { finishEnrollData, personalEnroll, getMajor } from "../api/updata";
import pageLoad from "../pageload/pageload";
export default {
  components: { pageLoad },
  data() {
    return {
      modal1: false, //对话框显示隐藏
      data: {},
      dict: {}, //数据、字典
      tip: "",
      tipShow: false, //提示框
      specialty: [], //专业
      profession: {},
      loading: true, //loading层
      kslbm: 0,
      year: "", //年
      zyNum: [
        { id: 1, value: 0 },
        { id: 2, value: 0 },
        { id: 3, value: 0 },
        { id: 4, value: 0 },
        { id: 5, value: 0 },
        { id: 6, value: 0 }
      ],
      disabled: true, //不可编辑
      show: false //提交隐藏
    };
  },
  created() {
    this._personalEnroll(); // 报名信息，初次获取
  },
  methods: {
    // 对话框
    ok() {
      this._finishEnrollData();
    },
    cancel() {
      this.modal1 = false;
    },
    //提交按钮
    _finishEnrollData() {
      let module = {
        sfzjh: Base64.encode(this.data.sfzjh),
        xm: this.data.xm,
        batch_id: this.data.batch_id,
        xzm: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).xzm,
        zyid: JSON.stringify(this.zyNum)
      };
      finishEnrollData(module)
        .then(res => {
          if (res.status) {
            this.tipCtr(res.msg);
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },

    // 报名信息，初次获取
    _personalEnroll() {
      let that = this;
      let module = {
        sfzjh: this.global.Base64.encode(
          JSON.parse(this.global.Base64.decode(sessionStorage.getItem("INFO")))
            .sfzjh
        ),
        xm: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).xm,
        batch_id: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).batch_id
      };
      this.loading = true;
      personalEnroll(module)
        .then(res => {
          if (res.status) {
            this.year = res[0].data.year;
            that.data = res[0].data;
            that.dict = res[0].dict;
            this.zyNum[0].value = that.data.zyid1;
            this.zyNum[1].value = that.data.zyid2;
            this.zyNum[2].value = that.data.zyid3;
            this.zyNum[3].value = that.data.zyid4;
            this.zyNum[4].value = that.data.zyid5;
            this.zyNum[5].value = that.data.zyid6;
            this._getMajor(); //获取学制专业

            //已经被录取  state=3
            // if (that.data.state == 3) {
            //   this.disabled = false;
            //   this.show = true;
            // } else {
            //   this.disabled = true;
            //   this.show = false;
            // }
          } else {
            this.loading = false;
            this.tipCtr("暂无数据");
          }
        })
        .catch(() => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //获取学制专业
    _getMajor() {
      let module = {
        xzm: JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).xzm,
        sch_id: 1,
        year: this.year
      };
      this.loading = false;
      getMajor(module)
        .then(res => {
          if (res.status && res.data) {
            for (var i in res.data) {
              let tmpV = res.data[i].zyxx;
              for (var j in tmpV) {
                this.specialty.push({ id: tmpV[j].id, name: tmpV[j].name });
              }
            }
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(() => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>

<style scoped>
.none {
  color: white !important;
}
.item {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/encrollApplication.vue